const styles = {
  title: {
    fontSize: '32px',
  },

  content__padding: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },

  footer: {
    display: 'flex',
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
};

export default styles;
